// Legacy React hooks - kept for potential future use
// import {useEffect, useRef} from 'react';
import {makeAutoObservable, onBecomeObserved, runInAction} from 'mobx';
import {makeLoggable} from 'mobx-log';

import apiService from '../transport/apiService';
import {OrderLine} from '../transport/apiServiceResponse';
import {logError} from '../utils/errorLogging';

export type LinesParams = Parameters<typeof apiService.searchLines>[0];

/**
 * General purpose store for lines. Not in mobx state tree
 */
export class LinesStore {
  lines: OrderLine[] = [];
  isLoading: boolean = false;

  private params: LinesParams;

  constructor(params: LinesParams) {
    this.params = params;

    makeAutoObservable(this);
    makeLoggable(this);
    onBecomeObserved(this, 'lines', this.load);
  }

  /**
   * Drop cached lines without destroying the instance. Mounted observers keep
   * this object across auth flips; wiping only `rootStore.linesStore` does not
   * notify them or re-fire `onBecomeObserved`.
   */
  invalidate = () => {
    runInAction(() => {
      this.lines = [];
      this.isLoading = false;
    });
  };

  /** Refetch under the current session (cookie / x-session-id). */
  reload = () => this.load();

  private load = async () => {
    runInAction(() => {
      this.isLoading = true;
    });
    try {
      const lines = await apiService.searchLines(this.params);
      runInAction(() => {
        this.lines = lines;
      });
    } catch (e) {
      logError(e, 'LinesStore.load');
    }
    runInAction(() => {
      this.isLoading = false;
    });
  };
}
